import React, { useState } from 'react';

export default function TripTypeForm({ tripType, guide, onSave, onCancel }) {
  const [values, setValues] = useState(tripType || {
    name: '',
    description: '',
    duration_hours: 8,
    price_per_seat: 250,
    deposit_per_seat: guide.default_deposit_per_seat,
    default_capacity: guide.default_capacity,
    default_start_time: '06:00'
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const update = ({ target }) => {
    const numeric = ['duration_hours', 'price_per_seat', 'deposit_per_seat', 'default_capacity'];
    setValues({
      ...values,
      [target.name]: numeric.includes(target.name) ? Number(target.value) : target.value
    });
  };

  const submit = async (event) => {
    event.preventDefault();
    setSaving(true);
    setError('');

    const result = await onSave(values);

    setSaving(false);

    if (result?.ok === false) {
      setError(result.error);
      return;
    }

    onCancel();
  };

  return (
    <form className="form-stack" onSubmit={submit}>
      {error && <div className="alert error">{error}</div>}
      <label>
        Trip Name
        <input name="name" value={values.name} onChange={update} required />
      </label>
      <label>
        Description
        <textarea name="description" rows="3" value={values.description} onChange={update} required />
      </label>
      <div className="form-grid">
        <label>
          Duration in Hours
          <input type="number" step="0.5" min="0.5" name="duration_hours" value={values.duration_hours} onChange={update} required />
        </label>
        <label>
          Default Start Time
          <input type="time" name="default_start_time" value={values.default_start_time} onChange={update} required />
        </label>
      </div>
      <div className="form-grid">
        <label>
          Price Per Seat
          <input type="number" min="0" name="price_per_seat" value={values.price_per_seat} onChange={update} required />
        </label>
        <label>
          Deposit Per Seat
          <input type="number" min="0" name="deposit_per_seat" value={values.deposit_per_seat} onChange={update} required />
        </label>
      </div>
      <label>
        Default Capacity
        <input type="number" min="1" name="default_capacity" value={values.default_capacity} onChange={update} required />
      </label>
      <div className="form-actions">
        <button type="button" className="button secondary" onClick={onCancel}>Cancel</button>
        <button className="button primary" disabled={saving}>
          {saving ? 'Saving…' : 'Save Trip Type'}
        </button>
      </div>
    </form>
  );
}